import React, { Component } from "react";

import HeaderMenu from "components/jobs/HeaderMenu";
import Logo from "components/general/Logo";
import PillButton from "components/general/PillButton";
import { connect } from "react-redux";
import styled from "styled-components";
import theme from "styles/theme";

const Background = styled.div`
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 64px;
  ${(props) =>
    props.isGray
      ? `background-color: ${theme.colors.gray1};`
      : `background-color: ${theme.colors.white};`}

  ${(props) =>
    !props.isGray &&
    !props.$isShadowHidden &&
    "box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);"}
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  max-width: 1440px;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 0 ${theme.spacing.unit * 4}px;

  ${theme.media.phone`
    padding: 0 ${theme.spacing.unit * 2}px;
  `}
`;

const LeftItem = styled.div`
  flex-basis: 0%;
  flex-grow: 1;
`;

const MiddleItem = styled.div``;

const RightItem = styled.div`
  flex-basis: 0%;
  flex-grow: 1;
  text-align: right;
`;

const StyledMiddleItemText = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 122%;
`;

const RightPillButtonGroupContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: -${theme.spacing.unit * 1}px;
`;

const PillButtonContainer = styled.div`
  margin: ${theme.spacing.unit * 1}px;
`;

export const ItemLogo = () => {
  return <Logo />;
};

export const LeftItemPillButton = ({ title, icon, isIconOnly, onClick }) => {
  return (
    <PillButton isGhost icon={icon} isIconOnly={isIconOnly} onClick={onClick}>
      {title}
    </PillButton>
  );
};

export const MiddleItemText = ({ title, darkMode }) => {
  return (
    <StyledMiddleItemText darkMode={darkMode}>{title}</StyledMiddleItemText>
  );
};

export const RightItemPillButton = ({ title, onClick }) => {
  return (
    <PillButton isPrimary onClick={onClick}>
      {title}
    </PillButton>
  );
};

export const RightItemPillButtonGroup = ({ pillButtons }) => {
  return (
    <RightPillButtonGroupContainer>
      {pillButtons.map((pillButton, i) => (
        <PillButtonContainer key={i}>{pillButton}</PillButtonContainer>
      ))}
    </RightPillButtonGroupContainer>
  );
};

export const ItemMenu = () => {
  return <HeaderMenu />;
};

export class Header extends Component {
  render() {
    let { className, left, middle, right, isGray, isShadowHidden } = this.props;

    return (
      <Background
        className={className}
        data-cy-header
        isGray={isGray}
        $isShadowHidden={isShadowHidden}
      >
        <Container>
          <LeftItem>{left}</LeftItem>
          <MiddleItem>{middle}</MiddleItem>
          <RightItem data-cy-header-right>{right}</RightItem>
        </Container>
      </Background>
    );
  }
}

function mapStateToProps(state) {
  const { auth } = state;
  return { user: auth.user };
}

export default connect(mapStateToProps)(Header);
